import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from "axios";
import '../../App.css';
import '../styles/NltxClients.css'
import ChartPie from '../js/ChartPie';
import ChartLine from '../js/ChartLine';
import ChartBarOrdinal from '../js/ChartBarOrdinal';

export default function NltxClients() {
    useEffect(() => {
        document.title = "Analytics | Clients"; // Set the tab name
    }, []);

    // TODO revise upper data blocks
    const [dataCounts, setDataCounts] = useState({
        clientAlpha: 0,
        clientBravo: 0,
        clientCharlie: 0,
        clientDelta: 0
    });

    const [updateTrigger, setUpdateTrigger] = useState(false);
    
    const abbreviateNumber = (number) => {
        if (number >= 1_000_000) {
            return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Abbreviate to 'M' for millions
        } else if (number >= 1_000) {
            return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Abbreviate to 'K' for thousands
        }
        return number.toString(); // Return the number as a string if under 1,000
    };


    useEffect(() => {
        const fetchDataCounts = async () => {
          try {
            const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/your-endpoint.php'); // TODO refer to api folder in htdocs
            setDataCounts({
              clientAlpha: abbreviateNumber(response.data.clientAlpha),
              clientBravo: abbreviateNumber(response.data.clientBravo),
              clientCharlie: abbreviateNumber(response.data.clientCharlie),
              clientDelta: abbreviateNumber(response.data.clientDelta)
            });
          } catch (error) {
            //console.error("Error fetching data counts:", error);
          }
        };
    
        fetchDataCounts();
    }, [updateTrigger]); // Only calls when updateTrigger changes

    const refreshTopData = () => {
        setUpdateTrigger(!updateTrigger);
    };  

    const navigate = useNavigate();

    // pie data
    const example1 = [
        {property: 'Personal Identification', value: 11},
        {property: 'Admin', value: 3},
        {property: 'Support', value: 4}
    ] 

    // lines data
    const example2 = [
        {date: new Date("2024-06-01"), value: 100},
        {date: new Date("2024-07-01"), value: 67},
        {date: new Date("2024-08-01"), value: 92}
    ]

    const example3 = [
        {date: new Date("2024-06-01"), value: 80},
        {date: new Date("2024-07-01"), value: 100},
        {date: new Date("2024-08-01"), value: 75}
    ]

    return (
        <div>
            <div className="analytics-heading">
                <strong className='text'>Client Analytics</strong>
            </div>
            <section className='dash_overview'>
                <article className='stat_box standalone'>
                    <h6 className='title analytics-card'>Something</h6>
                    <p className='title body analytics-card'>{dataCounts.clientAlpha}</p>
                </article>
                <article className='stat_box standalone'>
                    <h6 className='title analytics-card'>Something&nbsp;here</h6>
                    <p className='title body analytics-card'>{dataCounts.clientBravo}</p>
                </article>
                <article className='stat_box standalone'>
                    <h6 className='title analytics-card'>Something&nbsp;here</h6>
                    <p className='title body analytics-card'>{dataCounts.clientCharlie}</p>
                </article>
                <article className='stat_box standalone'>
                    <h6 className='title analytics-card'>Something&nbsp;else</h6>
                    <p className='title body analytics-card'>{dataCounts.clientDelta}</p>
                </article>
            </section>

            <section className='dash_overview' style={{ marginTop: '20px' }}>
                <article className='stat_box standalone'>
                    <h6 className='title analytics-card'>Purpose&nbsp;of&nbsp;Request</h6>
                    <ChartPie dataProps={example1}/>
                </article>

                <article className='stat_box standalone'>
                    <h6 className='title analytics-card'>Applications&nbsp;&&nbsp;Graduations</h6>
                    <ChartLine dataProps1={example2} dataProps2={example3} nameProps1='Applications' nameProps2='Graduations' />
                </article>

                <article className='stat_box standalone'>
                    <h6 className='title analytics-card'>Feedback</h6>
                    <ChartBarOrdinal />
                </article>
            </section>
            
        </div>
    )
}
